import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import DashboardLayout from "../../../shared/layouts/dashboard";


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const AccountGrouping = Loadable(lazy(() => import('../view/AccountGrouping')));
const GroupAccounts = Loadable(lazy(() => import('../components/GroupAccounts')));

export const AccountGroupingRoutes = [
    // Dashboard Routes
    {
        path: 'dashboard',
        element: (
            <AuthGuard>
                <DashboardLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'account-groupings', element: <AccountGrouping /> },
            { path: 'account-groupings/accounts/:code', element: <GroupAccounts /> },
        ],
    },
];
